import React from "react";
import styles from "./title.module.css";

export default function Title({name, children, consultation}) {
    return (
        <div className={`${styles.titleContainer} ${consultation ? styles.titleConsultation : ''} my-3`}>
            <div>{name}</div>
            <div>{children}</div>
        </div>
    );
}